import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Scroll-Reveal: Inhalte erscheinen beim Scrollen von unten nach oben
 * mit Blur-Auflösung. Respektiert prefers-reduced-motion.
 *
 * <Reveal>...</Reveal>            – Standard (y: 48px, Blur 10px)
 * <Reveal delay={0.2}>            – verzögert
 * <Reveal as="span" y={24}>       – anderes Element / kleinerer Weg
 */
export default function Reveal({
  children,
  as = 'div',
  delay = 0,
  duration = 0.8,
  y = 48,
  blur = 10,
  once = true,
  className = '',
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduceMotion) {
    const Plain = as;
    return <Plain className={className} {...rest}>{children}</Plain>;
  }

  return (
    <Component
      initial={{ opacity: 0, y, filter: `blur(${blur}px)` }}
      whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      viewport={{ once, margin: '-80px 0px' }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </Component>
  );
}

/** Container, der Kinder nacheinander einblendet */
export function RevealGroup({ children, stagger = 0.12, className = '' }) {
  return (
    <div className={className}>
      {React.Children.map(children, (child, i) =>
        child ? <Reveal delay={i * stagger}>{child}</Reveal> : null
      )}
    </div>
  );
}
